import React, { useState, useMemo, useEffect } from 'react';
import './AssetSelector.css';
import { IGatewaysModel, IAssociatedIcon } from './types';


interface IIconValue {
    SVG: string;
    Class: string;
}

interface GatewaySelectorProps {
    gateways: IGatewaysModel[];
    onSelectionChange: (selectedGateways: IGatewaysModel[]) => void;
    httpClient: any;
}
const IconDisplay: React.FC<{ icon: IGatewaysModel['associatedIcon'] }> = ({ icon }) => {
    if (!icon || !icon.Value) return null;
    if (icon.Value.SVG) {
        return (
            <div
                className="asset-icon"
                style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                dangerouslySetInnerHTML={{ __html: icon.Value.SVG }}
            />
        );
    }

    // CORREÇÃO: Usa Google Material Icons para consistência
    if (icon.Value.Class) {
        return (
            <div className="asset-icon" style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span className="material-icons-outlined" style={{ fontSize: '20px' }}>
                    {icon.Value.Class}
                </span>
            </div>
        );
    }

    return null;
};


export const GatewaySelector: React.FC<GatewaySelectorProps> = ({ gateways, onSelectionChange, httpClient }) => {
    const [filterText, setFilterText] = useState('');
    const [selectedIds, setSelectedIds] = useState<number[]>([]);

    const filteredGateways = useMemo(() => {
        if (!filterText) return gateways;
        return gateways.filter(gateway =>
            // Filtro ajustado para as propriedades do gateway
            `${gateway.Gateway} ${gateway.LocalDescricao || ''}`.toLowerCase().includes(filterText.toLowerCase())
        );
    }, [filterText, gateways]);

    const handleToggleSelection = (gatewayId: number) => {
        const newSelectedIds = selectedIds.includes(gatewayId)
            ? selectedIds.filter(id => id !== gatewayId)
            : [...selectedIds, gatewayId];

        setSelectedIds(newSelectedIds);
    };

    useEffect(() => {
        // Lógica de seleção ajustada para o modelo de gateway
        const selectedModels = gateways.filter(gateway => selectedIds.includes(gateway.IdGateway));
        onSelectionChange(selectedModels);
    }, [selectedIds, gateways, onSelectionChange]);


    return (
        <div className="asset-selector-container">
            <label htmlFor="filter">Buscar Gateway:</label>
            <input
                type="text"
                id="filter"
                placeholder="Filtrar por nome ou descrição do local..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
            />

            <label>Selecionar Gateways:</label>
            <ul className="asset-list">
                {filteredGateways.map(gateway => (
                    <li
                        key={gateway.IdGateway}
                        className={`asset-list-item ${selectedIds.includes(gateway.IdGateway) ? 'selected' : ''}`}
                        onClick={() => handleToggleSelection(gateway.IdGateway)}
                    >
                        <div className="asset-info">
                            <input
                                type="checkbox"
                                checked={selectedIds.includes(gateway.IdGateway)}
                                readOnly
                            />
                            <span className="asset-text">{gateway.Gateway} - {gateway.LocalDescricao || gateway.Local}</span>
                        </div>
                        <IconDisplay icon={gateway.associatedIcon} />
                    </li>
                ))}
            </ul>
        </div>
    );
};